import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from as fromPromise, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import {
    OrderMakeChangesResponse,
    orderMakeChangesResponseDecoder
} from '@trade-platform/ui-shared';

@Injectable()
export class OrderMakeChangesService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderMakeChanges(orderId: string): Observable<OrderMakeChangesResponse> {
        return this.http
            .post<OrderMakeChangesResponse>(
                `${this.environment.api}orders/${orderId}/makeChanges`,
                {
                    id: orderId
                }
            )
            .pipe(concatMap(p => fromPromise(orderMakeChangesResponseDecoder.decodeToPromise(p))));
    }
}
